import { FC } from 'react';
import { alpha, Box, BoxProps, Stack, styled, Typography } from '@mui/material';
import classNames from 'classnames';

import { Icon, IconOption } from '../base';

type EmptyStateProps = {
  circleIcon?: boolean;
  description: string;
  heading?: string;
  icon: IconOption;
};

const iconSize = '80px';
const iconPadding: BoxProps['p'] = 3;

const LargeIcon = styled(Icon)`
  height: ${iconSize};
  width: ${iconSize};

  &.circle {
    background: ${({ theme }) => alpha(theme.palette.background.paper, 0.5)};
    border-radius: 50%;
    height: calc(${iconSize} + ${({ theme }) => theme.spacing(iconPadding * 2)});
    padding: ${({ theme }) => theme.spacing(iconPadding)};
    width: calc(${iconSize} + ${({ theme }) => theme.spacing(iconPadding * 2)});
  }
`;

export const EmptyState: FC<EmptyStateProps> = ({ description, icon, circleIcon, heading }) => (
  <Box
    display='flex'
    justifyContent='center'
    m='auto'
    px={{ xs: 2, sm: 4, md: 8 }}
    py={{ xs: 6, sm: 4 }}
    width={1}
  >
    <Stack
      alignItems='center'
      spacing={2}
      sx={{ color: theme => theme.palette.action.disabled }}
      textAlign='center'
    >
      <LargeIcon className={classNames({ circle: circleIcon })} color='inherit' name={icon} />

      <Stack>
        {heading && (
          <Typography color='inherit' component='p' gutterBottom variant='h3'>
            {heading}
          </Typography>
        )}

        <Typography color='inherit'>{description}</Typography>
      </Stack>
    </Stack>
  </Box>
);
